module.exports = __webpack_public_path__ + "Posters0005-dd5213e8e4b47337bee39b1334953f62.png";